<template>
     <b-row>
        <b-col v-if="showControls">
            <b-row class="pb-4">
                <b-col>
                    <b-row>
                        <b-col></b-col>
                        <b-col>
                            <b-button block
                                @focus="onFocus(xi18n(i8nPrefix, 'moveUp'))"
                                @click="moveMap(0, 1)">{{xi18n(i8nPrefix, 'moveUp')}}
                            </b-button>
                        </b-col>
                        <b-col></b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <b-button block
                                @focus="onFocus(xi18n(i8nPrefix, 'moveLeft'))"
                                @click="moveMap(-1, 0)">{{xi18n(i8nPrefix, 'moveLeft')}}
                            </b-button>
                        </b-col>
                        <b-col></b-col>
                        <b-col>
                            <b-button block
                                @focus="onFocus(xi18n(i8nPrefix, 'moveRight'))"
                                @click="moveMap(1, 0)">{{xi18n(i8nPrefix, 'moveRight')}}
                            </b-button>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col></b-col>
                        <b-col>
                            <b-button block
                                @focus="onFocus(xi18n(i8nPrefix, 'moveDown'))"
                                @click="moveMap(0, -1)">{{xi18n(i8nPrefix, 'moveDown')}}
                            </b-button>
                        </b-col>
                        <b-col></b-col>
                    </b-row>
                </b-col>
            </b-row>
            <b-row class="pb-4">
                <b-col>
                    <b-button-group>
                        <b-button
                            @focus="onFocus(xi18n(i8nPrefix, 'zoomIn'))"
                            :disabled="zoomLevel >= maxZoom"
                            @click="mapZoom(1)">{{xi18n(i8nPrefix, 'zoomIn')}}
                        </b-button>
                        <label class="px-4 mb-0 pt-1" aria-title="zoomLevel">{{zoomLevel}}/{{maxZoom}}</label>
                        <b-button
                            @focus="onFocus(xi18n(i8nPrefix, 'zoomOut'))"
                            :disabled="zoomLevel < 1"
                            @click="mapZoom(-1)">{{xi18n(i8nPrefix, 'zoomOut')}}
                        </b-button>
                    </b-button-group>
                </b-col>
            </b-row>
            <b-row class="pb-4">
                <b-col>
                    <b-button-group>
                        <b-button
                            v-if="hasStartingPoint"
                            @focus="onFocus(xi18n(i8nPrefix, 'resetMap'))"
                            @click="resetMap()">{{xi18n(i8nPrefix, 'resetMap')}}
                        </b-button>
                    </b-button-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-button-group v-if="showFocusControls" class="pb-4">
                        <b-button
                            @focus="onFocus(xi18n(i8nPrefix, 'focusSelection'))"
                            @click="focusSelection">{{xi18n(i8nPrefix, 'focusSelection')}}
                        </b-button>
                        <b-button
                            :disabled="!getSelectionObjectsSelectedItem"
                            @focus="onFocus(xi18n(i8nPrefix, 'focusSelected'))"
                            @click="focusSelected">{{xi18n(i8nPrefix, 'focusSelected')}}
                        </b-button>
                    </b-button-group>
                </b-col>
            </b-row>
        </b-col>
    </b-row>
</template>

<script>
    import { mapGetters, mapState, mapActions } from 'vuex';

    export default {
        data() {
            return { i8nPrefix: 'accessibility' };
        },
        computed: {
            ...mapState(['pointer']),
            ...mapGetters([
                'getSelectionObjectsCount',
                'getSelectionObjectsSelectedItem',
                'getMapViewPort',
                'getWebThemeParameters'
            ]),
            hasResults() {
                return this.getSelectionObjectsCount > 0;
            },
            hasSelected() {
                return this.getSelectionObjectsCount > 1;
            },
            hasStartingPoint() {
                return parseInt(this.getWebThemeParameters.zoom, 10) >= 0 && this.getWebThemeParameters.center;
            },
            zoomLevel() {
                const viewport  = this.getMapViewPort();
                return Math.round(viewport.zoom);
            },
            showControls() {
                return this.zoomLevel >= 0;
            },
            showFocusControls() {
                const focusActive = false;
                return focusActive && this.hasResults;
            },
            maxZoom() {
                return 14;
            },
            point() {
                if (!this.pointer) {
                    return null;
                }
                return { point: this.pointer?.location?.point };
            }
        },
        methods: {
            ...mapActions(['updateViewPortMap']),
            focusSelection() {
                const features = this.$store.getters.getSelectionObjects.map(item => item.feature);
                this.$store.dispatch('zoomToFeatures', {
                    features,
                    zoomWhenOutOfView: false
                });
            },
            focusSelected() {
                const feature = this.$store.getters.getSelectionObjectsSelectedItem.feature;
                this.$store.dispatch('zoomToFeatures', {
                    features: [feature],
                    zoomWhenOutOfView: false
                });
            },
            onFocus(text) {
                this.$store.dispatch('say', { text });
            },
            mapZoom(val) {
                const viewport  = this.getMapViewPort();
                const zoom = Math.max(0.001, Math.min(viewport.zoom + val, this.maxZoom));
                this.updateViewPortMap({ zoom });
            },
            moveMap(xDelta, yDelta) {
                const viewport  = this.getMapViewPort();
                const basefactor = (20 - viewport.zoom)/5;
                const factor = Math.pow(basefactor, 6);
                const currentCenter = viewport.center;
                const center = [currentCenter[0]+(xDelta*factor), currentCenter[1]+(yDelta*factor)];
                this.updateViewPortMap({ center });
            },
            resetMap() {
                this.updateViewPortMap({ zoom: this.getWebThemeParameters.zoom, center: this.getWebThemeParameters.center });
            }
        },
    };
</script>
